import standardAPI from '@/api/standard_items';

const state = {
  offices: [],
  offices_status: '',
  offices_MetaData: {},
  offices_page: 1,
  offices_perPage: 10,
};

const responseUrl = '/offices';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_offices ({ commit }, getOptions) {
    commit('OFFICES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('OFFICES_SUCCESS', response);
            commit('OFFICES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('OFFICES_READY');
            reject(response);
          } else {
            commit('OFFICES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_office ({ commit, dispatch }, itemData) {
    commit('OFFICES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('OFFICES_READY');
          reject(response);
        }
      });
    });
  },
  edit_office ({ commit, dispatch }, itemData) {
    commit('OFFICES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('OFFICES_READY');
          reject(response);
        }
      });
    });
  },
  remove_office ({ commit, dispatch }, itemData) {
    commit('OFFICES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('OFFICES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_office ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.offices_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.offices_perPage = max;
  },
  OFFICES_READY: (state) => {
    state.offices_status = 'ready';
  },
  OFFICES_REQUEST: (state) => {
    state.offices_status = 'loading';
  },
  OFFICES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.offices_MetaData.meta = response.meta;
      state.offices_MetaData.links = response.links;
    }
    state.offices = response.data;
    state.offices_status = 'success';
  },
  OFFICES_ERROR: (state) => {
    state.offices_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
